import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../hooks'
import { FormikField } from '../../../Formik'
import { InputField } from '../../../Input'
import { EmailFormContext } from '../../EmailForm.context'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT,
  EMAIL_CREATION_FORM_MAX_INPUT_LENGTH,
} from '../EmailCreationForm.constants'

import * as styles from '../EmailCreationForm.module.css'

function SubjectField() {
  const { t } = useTranslation()

  const { blocked } = useContext(EmailFormContext)

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      blocked={blocked}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Email.SubjectLabelKey')}:`,
        labelClassName: styles.fieldLabel,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={EMAIL_CREATION_FORM_MAX_INPUT_LENGTH}
      name={EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT}
      placeholder={t('Email.SubjectPlaceholderKey')}
      wrapperClassName={styles.input}
    />
  )
}

export default SubjectField
